import moment from "moment";

const formatUnix = date => {
  return new Date(parseFloat(date));
};

export const formatDate = date => {
  // Date object
  if (date instanceof Date) {
    return moment(date).format("MM/DD/YYYY");
  }

  // ISO string (e.g. YYYY-MM-DDTHH:MM:SS.mmmZ)
  if (
    typeof date === "string" &&
    moment(date, moment.ISO_8601, true).isValid()
  ) {
    return moment.utc(date).format("MM/DD/YYYY");
  }

  return moment(formatUnix(date)).format("MM/DD/YYYY");
};

export const formatFullDate = date => {
  if (typeof date === "object") {
    return (
      moment(date).format("MM/DD/YYYY") + " - " + moment(date).format("LT")
    );
  }

  // handle ISO strings
  if (typeof date === "string" && (date.includes("T") || date.includes("-"))) {
    return (
      moment(date).format("MM/DD/YYYY") + " - " + moment(date).format("LT")
    );
  }

  return (
    moment(formatUnix(date)).format("MM/DD/YYYY") +
    " - " +
    moment(formatUnix(date)).format("LT")
  );
};

export const formatDateShort = date => {
  return moment(date).format("MM/DD/YYYY");
};
